import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import Heatmap from 'react-calendar-heatmap';
import 'react-calendar-heatmap/dist/styles.css';
import './ContributionGraph.css';

const ContributionGraph = () => {
    const [contributions, setContributions] = useState([]);

    useEffect(() => {
        axios
            .get('https://api.github.com/users/Muqsit-hussain6/repos')
            .then((response) => {
                // Process the data and format the dates
                const data = response.data.map((repo) => ({
                    name: repo.name,
                    contributions: repo.contributions,
                    date: moment(repo.updated_at).format('YYYY-MM-DD'),
                }));

                // Set the state with the formatted data
                setContributions(data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    // Get the start date of the current year
    const startOfYear = moment().startOf('year');

    return (
        <div className="contribution-graph-container">
            <div className="heatmap-container">
                <Heatmap
                    startDate={startOfYear.toDate()}
                    endDate={new Date()}
                    values={contributions.map((contribution) => ({
                        date: moment(contribution.date).toDate(),
                        count: contribution.contributions,
                    }))}
                    classForValue={(value) => {
                        if (!value) {
                            return 'color-empty';
                        }
                        if (value.count > 20) {
                            return 'color-scale-4';
                        }
                        if (value.count > 10) {
                            return 'color-scale-3';
                        }
                        if (value.count > 5) {
                            return 'color-scale-2';
                        }
                        return 'color-scale-1';
                    }}
                    showWeekdayLabels={true}
                    titleForValue={(value) =>
                        value
                            ? `${moment(value.date).format('ddd, MMM D, YYYY')}: ${value.count} contributions`
                            : null
                    }
                    horizontal={true}
                />
            </div>
        </div>
    );
};

export default ContributionGraph;
